const InstEducativasRules  = () => {
return {
  nombreAlumno: [
    'required',
    'string',
  ],
  CURP: [
    'required',
    'string',
    'size:18',
    'regex:/^[A-Z][A,E,I,O,U,X][A-Z]{2}[0-9]{2}[0-1][0-9][0-3][0-9][M,H][A-Z]{2}[B,C,D,F,G,H,J,K,L,M,N,Ñ,P,Q,R,S,T,V,W,X,Y,Z]{3}[0-9,A-Z][0-9]?',
  ],
  nivelEducativo: [
    'required',
    'string',
    'in:Preescolar,Primaria,Secundaria,Profesional técnico,Bachillerato o su equivalente',
  ],
  autRVOE: [
    'required',
    'string',
    'min:1',
  ],
  rfcPago: [
    'string',
    'min:12',
    'max:13',
    'regex:/^[A-Z,Ñ,&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z,0-9]?[A-Z,0-9]?[0-9,A-Z]?',
  ],
}
};

export default InstEducativasRules;
